import {CircularProgress} from "@mui/material";
import React from "react";
import { CenteredCircularProgressContainer } from "./CenteredCircularProgress.styles";

export const FullscreenCenteredCircularProgress = () => <CenteredCircularProgressContainer>
    <CircularProgress/>
</CenteredCircularProgressContainer>
